console.log("saludoDesdeScript");

console.log("saludo");
console.log(menupop);


menupop.addEventListener('click', e=>{

    document.querySelector('.divMenuPop').style.display = "inline";
    console.log("saludo");
    window.setTimeout(function(){
        document.querySelector('.divMenuPop').classList.add('h-hide');
      },20); // do this asap      
    document.querySelector('.divMenuPop').style.transition = "all .6s linear"
 

})

closebtn.addEventListener('click', e=>{

    console.log("close");
    document.querySelector('.divMenuPop').style.display = "none";


})



